import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn 표준 cn 유틸 — Tailwind 클래스 병합
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
